import './global'
import './logger'
import './i18n'
// mc-mobile-mobile not use fdp $http inject
// import './network'
import './vuex'
import './directive'



// WEBPACK FOOTER //
// ./src/_fdp/core/index.js